import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataContentModule } from '@epicuro-next/data/content';
import { ContentBusinessComponentsModule } from '@epicuro-next/elements/content-business-components';
import { ContentComponentsModule } from '@epicuro-next/elements/content-components';
import {
  getPulseAngularElementsForChunk,
  ModuleWithPulseElements,
  PULSE_ELEMENTS_CHUNK,
} from '@epicuro-next/elements/core';
import {
  ConfigurationModule,
  NAMESPACE_CONTENT,
} from '@epicuro-next/platform/configuration';
import { StorageModule } from '@epicuro-next/platform/storage';

import { ContentPageComponent } from './containers/content-page/content-page.component';
import { ContentPlaygroundComponent } from './containers/content-playground/content-playground.component';
import { ContentSlotComponent } from './containers/content-slot/content-slot.component';

/** Content module */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DataContentModule,
    ContentComponentsModule,
    ContentBusinessComponentsModule,
    ConfigurationModule,
    ConfigurationModule.forFeature(NAMESPACE_CONTENT),
    ModuleWithPulseElements.forElementsChunk(PULSE_ELEMENTS_CHUNK.CONTENT),
    StorageModule,
    RouterModule.forChild([
      { path: 'playground', component: ContentPlaygroundComponent },
      { path: ':slotName', component: ContentPageComponent },
      { path: '', pathMatch: 'full', component: ContentPageComponent },
      { path: '**', redirectTo: '' },
    ]),
  ],
  declarations: [
    ContentPlaygroundComponent,
    ContentPageComponent,
    ContentSlotComponent,
  ],
})
export class ContentModule {
  constructor(private injector: Injector) {
    const elms = getPulseAngularElementsForChunk(PULSE_ELEMENTS_CHUNK.CONTENT);
    elms.forEach(({ constructor, selector }) => {
      // tslint:disable-next-line:no-any
      const customElm = createCustomElement(constructor as any, {
        injector: this.injector,
      });
      if (!customElements.get(selector)) {
        customElements.define(selector, customElm);
      }
    });
  }
}
